<template>
  <el-dialog 
    :title="$t('editService.editService')" 
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <el-form :model="editServiceInfo" :rules="rules" ref="editServiceForm" label-width="120px">
      <el-form-item :label="$t('editService.serviceName')" prop="name">
        <el-input 
          v-model="editServiceInfo.name" 
          :placeholder="$t('editService.enterServiceName')"
          clearable>
        </el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editService.serviceCode')" prop="serviceCode">
        <el-input 
          v-model="editServiceInfo.serviceCode" 
          :placeholder="$t('editService.enterServiceCode')"
          clearable>
        </el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editService.serviceUrl')" prop="url">
        <el-select 
          v-model="editServiceInfo.url" 
          :placeholder="$t('editService.selectServiceUrl')"
          style="width:100%">
          <el-option 
            v-for="(item,index) in editServiceInfo.services" 
            :key="index"
            :label="item.name"
            :value="item.statusCd">
          </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item :label="$t('editService.serviceMethod')" prop="method">
        <el-select 
          v-model="editServiceInfo.method" 
          :placeholder="$t('editService.selectServiceMethod')"
          style="width:100%">
          <el-option value="GET" label="http get"></el-option>
          <el-option value="POST" label="http post"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item :label="$t('editService.timeout')" prop="timeout">
        <el-input 
          v-model="editServiceInfo.timeout" 
          :placeholder="$t('editService.enterTimeout')"
          clearable>
        </el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editService.retryCount')" prop="retryCount">
        <el-input 
          v-model="editServiceInfo.retryCount" 
          :placeholder="$t('editService.enterRetryCount')"
          clearable>
        </el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editService">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { updateService } from '@/api/dev/serviceManage/serviceManageApi'

export default {
  name: 'EditService',
  data() {
    return {
      dialogVisible: false,
      editServiceInfo: {
        serviceId: '',
        name: '',
        serviceCode: '',
        businessTypeCd: 'API',
        seq: '1',
        messageQueueName: '',
        isInstance: 'T',
        url: 'http://community-service',
        method: '',
        timeout: '60',
        retryCount: '3',
        provideAppId: '8000418002',
        services: []
      },
      rules: {
        name: [
          { required: true, message: this.$t('editService.serviceNameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('editService.serviceNameMaxLength'), trigger: 'blur' }
        ],
        serviceCode: [
          { required: true, message: this.$t('editService.serviceCodeRequired'), trigger: 'blur' },
          { min: 2, max: 100, message: this.$t('editService.serviceCodeLength'), trigger: 'blur' }
        ],
        method: [
          { required: true, message: this.$t('editService.methodRequired'), trigger: 'change' }
        ],
        timeout: [
          { required: true, message: this.$t('editService.timeoutRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('editService.timeoutNumber'), trigger: 'blur' }
        ],
        retryCount: [
          { required: true, message: this.$t('editService.retryCountRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('editService.retryCountNumber'), trigger: 'blur' }
        ],
        serviceId: [
          { required: true, message: this.$t('editService.serviceIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(service) {
      this.dialogVisible = true
      Object.assign(this.editServiceInfo, service)
      this.getDictData()
    },
    async getDictData() {
      try {
        const {data} = await getDict('c_service', 'url')
        this.editServiceInfo.services = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleClose() {
      this.$refs.editServiceForm.resetFields()
      this.editServiceInfo = {
        serviceId: '',
        name: '',
        serviceCode: '',
        businessTypeCd: 'API',
        seq: '1',
        messageQueueName: '',
        isInstance: 'T',
        url: 'http://community-service',
        method: '',
        timeout: '60',
        retryCount: '3',
        provideAppId: '8000418002',
        services: []
      }
    },
    editService() {
      this.$refs.editServiceForm.validate(async valid => {
        if (valid) {
          try {
            await updateService(this.editServiceInfo)
            this.$message.success(this.$t('editService.saveSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('更新服务失败:', error)
          }
        }
      })
    }
  }
}
</script>